module.exports = __webpack_public_path__ + "img/before3.8a967e56.jpg";